import {ReactReduxContext, useDispatch, useSelector} from "react-redux";
import React, {useContext} from "react";
import FORM_DATA from "../steps/bi/constants/FORM_DATA";
import {setFormData} from "../../actions";

/**
 * A dropdown component for Step 4 of a form.
 * @param {Object} props - The properties of the component.
 * @param {string} props.elementName - The name of the dropdown element.
 * @param {string} props.dataSource - The data source for the dropdown options.
 * @param {string} props.labelText - The label text for the dropdown.
 * @param {any} props.value - The selected value of the dropdown.
 * @param {function} props.onChange - The onChange event handler for the dropdown.
 * @returns {JSX.Element} - The rendered dropdown component.
 */
export const Step4DropDown = ({elementName, dataSource, labelText, value, onChange}) => {
    const dispatch = useDispatch();
    const context = useContext(ReactReduxContext);
    const data = () => context.store.getState().app.stepData.step2[elementName];

    const val = useSelector(data);
    const source = FORM_DATA[dataSource];
    //  Uncomment if you want to remove the "Select..." option from the dropdown.
    // if(source[0].value === 0)
    // {
    //     source.shift();
    // }

    return (
        <div className="dropdown" key={'div_' + elementName}>
            <label htmlFor={elementName}>{labelText}</label>
            <select
                key={elementName + '_' + val}
                name={elementName}
                id={elementName}
                value={val} // controlled component using value prop
                onChange={e => {
                    e.preventDefault();
                    let v = {};
                    v['backup2'] = context.store.getState().app.stepData.step4.backup2;
                    v['backup2'][elementName] = parseInt(e.target.value);
                    dispatch(setFormData(4, v));
                    v = context.store.getState().app.stepData.step2;
                    v[elementName] = parseInt(e.target.value);
                    dispatch(setFormData(2, v));
                }}
            >
                {source.map(item => (
                    <option key={elementName + '_' + item.value} value={item.value}>{item.text}</option>
                ))}
            </select>
        </div>
    );
};